// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const floatzel: PokeData = {
  "id": 419,
  "name": "floatzel",
  "height": 11,
  "weight": 335,
  "base_experience": 173,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "razor-wind",
    "tackle",
    "tail-whip",
    "bite",
    "growl",
    "sonic-boom",
    "water-gun",
    "hydro-pump",
    "agility",
    "quick-attack",
    "waterfall",
    "swift",
    "pursuit",
    "crunch",
    "whirlpool",
    "water-sport",
    "water-pulse",
    "aqua-tail",
    "ice-fang",
    "aqua-jet",
    "double-hit",
    "soak",
    "liquidation",
    "wave-crash"
  ],
  "moves": [
    "tackle",
    "bite",
    "growl",
    "hydro-pump",
    "quick-attack",
    "pursuit",
    "crunch",
    "whirlpool",
    "aqua-tail",
    "ice-fang",
    "aqua-jet",
    "liquidation",
    "brine"
  ],
  "evolution_chain": {
    "id": 216,
    "item": null,
    "species": [
      {
        "name": "buizel",
        "order": 446,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "floatzel",
        "order": 447,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 418,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 159,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
